import * as keyapis_multiapp_v1_app_pb from "./v1/keyapis_multiapp_app_v1.pb";
import * as keyapis_multiapp_v1_notification_pb from "./v1/keyapis_multiapp_notification_v1.pb";
import * as keyapis_multiapp_v1_notification_template_pb from "./v1/keyapis_multiapp_notification_template_v1.pb";
import * as keyapis_multiapp_v1_partner_pb from "./v1/keyapis_multiapp_partner_v1.pb";
import * as keyapis_multiapp_v1_system_pb from "./v1/keyapis_multiapp_system_v1.pb";

export default {
  v1: {
    resources: {
      app: keyapis_multiapp_v1_app_pb,
      notification: keyapis_multiapp_v1_notification_pb,
      notificationTemplate: keyapis_multiapp_v1_notification_template_pb,
      partner: keyapis_multiapp_v1_partner_pb,
      system: keyapis_multiapp_v1_system_pb,
    },
  },
};
